<template>
  <div class="text-sm">
    <p class="mt-6"><b>2025.03.03</b> - Armor Break</p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>Fixed a bug causing Armor Break to have no effect</li>
      <li>
        <div>Armor Break potency decreased:</div>
        <div>
          <code>15 + L*(St/7 + De/10)</code> -->
          <code>10 + L*(St/12 + De/15)</code>
        </div>
      </li>
      <li>Updated the AI decision making on when to use Armor Break.</li>
      <li>Fixed a bug calculating damage mods from affinities.</li>
      <li>
        Enemy targeting AI now takes stances & affinities into account when calculating
        lowest effective health, not just armor.
      </li>
    </ul>
  </div>
</template>
